export default __webpack_public_path__ + "static/media/Message.a7e0f484.svg";